/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProjectRole } from './ProjectRole';
import {
    instanceOfProjectRole,
    ProjectRoleFromJSON,
    ProjectRoleFromJSONTyped,
    ProjectRoleToJSON,
} from './ProjectRole';

/**
 * @type ProjectUserOutputRole
 * 
 * @export
 */
export type ProjectUserOutputRole = ProjectRole;

export function ProjectUserOutputRoleFromJSON(json: any): ProjectUserOutputRole {
    return ProjectUserOutputRoleFromJSONTyped(json, false);
}

export function ProjectUserOutputRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectUserOutputRole {
    if (json == null) {
        return json;
    }
    if (instanceOfProjectRole(json)) {
        return ProjectRoleFromJSONTyped(json, true);
    }

    return {} as any;
}

export function ProjectUserOutputRoleToJSON(json: any): any {
    return ProjectUserOutputRoleToJSONTyped(json, false);
}

export function ProjectUserOutputRoleToJSONTyped(value?: ProjectUserOutputRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfProjectRole(value)) {
        return ProjectRoleToJSON(value as ProjectRole);
    }

    return {};
}

